var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopCheckList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 10 36 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#laptop-check-list_svg__clip0_11488_91365)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#laptop-check-list_svg__clip1_11488_91365)",
    fill: "#002147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.25 33.875h-.375a.75.75 0 01-.75-.75v-17.25a3.75 3.75 0 00-3.75-3.75H5.625a3.75 3.75 0 00-3.75 3.75v17.25a.75.75 0 01-.75.75H.75a.75.75 0 00-.75.75 5.25 5.25 0 005.25 5.25h25.5a5.25 5.25 0 005.25-5.25.75.75 0 00-.75-.75zm-4.125-.75a.75.75 0 01-.75.75H5.625a.75.75 0 01-.75-.75v-17.25a.75.75 0 01.75-.75h24.75a.75.75 0 01.75.75v17.25z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 18.5,
    width: 12,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 26,
    width: 7.5,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 17a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-4zm1.658 3.703l1.502-2.038a.402.402 0 01.72.173.399.399 0 01-.064.286l-.004.006-.005.007-1.75 2.367a.4.4 0 01-.572.076l-1.241-.993a.402.402 0 01-.105-.595.4.4 0 01.603-.021l.916.732zM8.5 24.5a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-4zm1.658 3.703l1.502-2.038a.402.402 0 01.72.173.399.399 0 01-.064.286l-.004.006-.005.007-1.75 2.367a.4.4 0 01-.572.076l-1.241-.993a.402.402 0 01-.105-.595.4.4 0 01.603-.021l.916.732z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "laptop-check-list_svg__clip0_11488_91365"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 8)",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "laptop-check-list_svg__clip1_11488_91365"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 8)",
    d: "M0 0h36v36H0z"
  })))));
}
export default SvgLaptopCheckList;